import { render, staticRenderFns } from "./ProductDetail_Digital.vue?vue&type=template&id=7235a54a&scoped=true"
import script from "./ProductDetail_Digital.vue?vue&type=script&lang=js"
export * from "./ProductDetail_Digital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7235a54a",
  null
  
)

export default component.exports